/**
 * This script is responsible for bootstraping the Finesse-IMI Gadget by
 * resolving and loading the IMI Engage Web Component
 */
import { useEffect, useState, useRef} from "react";
import ReactDOM from "react-dom";
import FinIMI from "./fin-imi";
import { TaskListStoreProvider } from "../Store";
import ErrorPage from "./errorPage";
import { i18n } from "../utils/GadgetUtils";
import styles from  './style.css';
import React from 'react';
import clusterIdDcMap from "./../ClusterIdDcMapping.json";

function Container() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const config = {
        logger: {
          info: (data) => {
            console.log(data);
          },
          error: (data) => {
            console.error(data);
          },
        },
        cb: (name, data) => {
          const event = new CustomEvent(name, {
            detail: data
          });
          window.dispatchEvent(event);
          // showNotification('EVENT', name);
        },
    };

    let orgID, dcVersion;
    window.AGENTX_SERVICE = {};
    window.logger = {};
    const systemAuthMode = window.finesse.container.Config.systemAuthMode;
    var prefs = new gadgets.Prefs();
    var useFinesseSimulator = prefs.getBool('use-finesse-imi-simulator');
    var imiEngageVersion = prefs.getString('imiengage-version');
    if (!useFinesseSimulator) {
        useFinesseSimulator = false;
    }
    function imiengagesuccessFn (e) {
        window.imiEngageWC = new window.ImiEngageWC(config);
        window.imiEngageWC.setParam("data", {
            "jwt": window.finesse.container.Config.authToken, // Needs to be changed., window.finesse.utilities.Utilities.getAuthHeaderString()
            "lang": window.finesse.container.Config.locale.replace('_', '-'),
            // "lang": "en-US",
            "theme":"LIGHT",
            "uiCB":null, 
            "source":"CCE",
            // "orgId": "53b4da38-666b-4268-b6f8-f52ae2a487c2" // Needs to be changed.
            "orgId": orgID
        });
        setLoading(false);
    };

    function imiengageErrorFn (e) {
        const errorInfo = {
            title: i18n.getMsg('gadget.imi.gadgetLoad.failure.title'),
            description: i18n.getMsg('gadget.imi.gadgetLoad.failure.description')
        }
        setError(error => errorInfo);
        setLoading(loading => false);
        console.error('Error occurred while loading the IMI Engage Webcomponent: ', errorInfo);
    };
    useEffect(() => {
        if (isFNCGadgetAvailable() && systemAuthMode === 'SSO') {
            document.addEventListener("imi-engage-bundle-load-success", imiengagesuccessFn);
            document.addEventListener("imi-engage-bundle-load-error", imiengageErrorFn);
            let digitalChannelConfig = new window.finesse.restservices.DigitalChannelsConfiguration(
                {
                    onLoad: (dc) => {                     
                        orgID = dc.getData().Configuration.OrgID;
                        dcVersion =  dc.getData().Configuration.DataCenter;
                        console.log('Digital channel configuration is ', orgID, dcVersion);
                        if (!useFinesseSimulator) {
                           if (!orgID) {
                                console.error('Digital channel configuration does not have orgID configured');
                                // Set error for FNC not available
                                const errorInfo = {
                                    title: i18n.getMsg('gadget.imi.gadgetLoad.failure.title'),
                                    description: i18n.getMsg('gadget.imi.gadgetLoad.failure.description')
                                }
                                setError(error => errorInfo);
                                setLoading(loading => false);
                            } 
                            if (!dcVersion) {
                                dcVersion = "staging";
                            } else {
                                dcVersion = dcVersion.toLowerCase();
                                if (clusterIdDcMap[dcVersion])  {
                                    dcVersion = clusterIdDcMap[dcVersion];
                                } else {
                                    console.error('Digital channel configuration does not have valid dcversion configured');
                                    const errorInfo = {
                                        title: i18n.getMsg('gadget.imi.gadgetLoad.failure.title'),
                                        description: i18n.getMsg('gadget.imi.gadgetLoad.failure.description')
                                    }
                                    setError(error => errorInfo);
                                    setLoading(loading => false);
                                } 
                            }
                        }
                        fetchIMIScript();
                    }, 
                    onError: () => {
                        // Set error for FNC not available
                        const errorInfo = {
                            title: i18n.getMsg('gadget.imi.gadgetLoad.failure.title'),
                            description: i18n.getMsg('gadget.imi.gadgetLoad.failure.description')
                        }
                        setError(error => errorInfo);
                        setLoading(loading => false);
                        console.error('Error occurred while loading the IMI Engage Webcomponent: ', errorInfo);
                    }
                });
        } else {
            // Set error for FNC not available
            const errorInfo = {
                title: i18n.getMsg('gadget.imi.gadgetLoad.failure.title'),
                description: i18n.getMsg('gadget.imi.gadgetLoad.failure.description')
            }
            setError(error => errorInfo);
            setLoading(loading => false);
            console.error('FNC is not available or system is not in SSO mode ', errorInfo);
        }

        return () => {
            document.removeEventListener("imi-engage-bundle-load-success", imiengagesuccessFn);
            document.removeEventListener("imi-engage-bundle-load-error", imiengageErrorFn);
        }
    }, [])

    async function fetchIMIScript () {
            var scriptEle = getIMIScript();
            scriptEle.onload = function () {
                // used in case of simulator is true
                if (useFinesseSimulator) setLoading(false);
                // else start settimeout check if bundles are not loaded... TODO
            };
            scriptEle.onerror = function () {
                const errorInfo = {
                    title: i18n.getMsg('gadget.imi.gadgetLoad.failure.title'),
                    description: i18n.getMsg('gadget.imi.gadgetLoad.failure.description')
                }
                setError(error => errorInfo);
                setLoading(loading => false);
                console.error('Error occurred while loading the IMI Engage Webcomponent: ', errorInfo);
            };
            document.head.appendChild(scriptEle);
    }
    
     function getIMIScript () {
        let finesseSimulatorHost = prefs.getString('finesse-imi-simulator-host');
        let cloudEngageURL = prefs.getString('engage-url');
        if (!cloudEngageURL) {
            cloudEngageURL = 'https://wc.imiengage.io/engage.js';
        }
        if (!finesseSimulatorHost) {
            finesseSimulatorHost = 'finesse25.autobot.cvp';
        }

        const IMI_SIMULATOR_URL = 'https://' + finesseSimulatorHost + ':8445' + '/3rdpartygadget/files/ManageDigitalChannel/engage.js';
        console.log('gadget urls prefs simulatorhost, usesimulator, cloudengageurl, imiEngageVersion ',finesseSimulatorHost , useFinesseSimulator, cloudEngageURL, imiEngageVersion);
        const IMI_ENGAGE_URL = useFinesseSimulator  ? IMI_SIMULATOR_URL : cloudEngageURL;
        const script = document.createElement('script');
        // TODO: Uncomment the script attributes when using the actual IMI web component
        script.id = 'imi-controller-bundle';
        script.src = IMI_ENGAGE_URL;
        if (!imiEngageVersion) {
            imiEngageVersion = 'latest';
        }
        if (imiEngageVersion !== 'latest') {
            console.log('finesse imiEngageVersion', imiEngageVersion); 
            script.setAttribute("version", imiEngageVersion);
        }
        script.setAttribute("dc", dcVersion?.toLowerCase());
        return script;
    }
    
    function isFNCGadgetAvailable () {
        if (window.top.document.getElementById('nonvoice-state-menu')) {
            return true;
        }
        return false;
    }

    function retry () {
        setLoading(true);
        setError(null);
        fetchIMIScript();
    }

    return (
        <>
            {loading ? <div className={styles.spinnerContainer}><md-spinner size={36} /></div>
            :
            error ? 
                <ErrorPage errorInfo={error} onRetry={retry} />
                : <TaskListStoreProvider><FinIMI orgID={orgID}/></TaskListStoreProvider>
            }
        </>
    )
}

ReactDOM.render(<Container />, document.getElementById('finesseIMIGadget'));

export default Container